<!-- MP看板-账户 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<div class="jl-screen-box">
				<a-dropdown-button @click="handleButtonClick">
				    批量操作
					<a-menu slot="overlay" @click="handleMenuClick">
						<a-menu-item key="2"> <a-icon type="align-right" />同步账户信息</a-menu-item>
						<a-menu-item key="1"> <a-icon type="align-right" />同步历史数据</a-menu-item>
						<a-menu-item key="3"> <a-icon type="align-right" />开启关闭同步数据</a-menu-item>
						<a-menu-item key="7"> <a-icon type="align-right" />设置推广内容</a-menu-item>
					</a-menu>
				</a-dropdown-button>
			</div>
			
			<div class="jl-screen-box">
				<div class="screen-label" style="margin-right: 7px;">精简模式</div>
				<a-switch :checked="jj_checked" default-checked @change="onJJChange" checked-children="开" un-checked-children="关" />
			</div>
			
			<div style="display: flex;align-items: center;padding-right: 10px;flex-wrap: wrap;">
				<div class="jl-screen-box">
					<a-range-picker style="width:220px;" @change="onChangeDate" :allowClear="false"
					:locale="locale" 
					:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
				</div>
				
				<div v-if="Object.keys(personChargeList).length > 0" class="jl-screen-box">
					<a-select
						mode="multiple" 
						style="min-width: 150px;max-width: 390px;"
						placeholder="请选择投手"
						@change="handleChangeA"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						:value="r_admin_id"
						allowClear
						showSearch
					  >
						<a-select-option value="-1">未设置</a-select-option>
						<a-select-option v-for="(value,key) in personChargeList" :key="key" :value="key">
						  {{value}}
						</a-select-option>
					</a-select>
				</div>
				
				
				<div class="jl-screen-box">
					<a-input v-model="r_account_id" allowClear placeholder="请输入广告账户ID" style="width: 200px;"  />
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_account_name" allowClear placeholder="请输入广告账户名称" style="width: 200px;"  />
				</div>
				
				<div class="jl-screen-box">
					<a-select
						style="width: 180px"
						placeholder="请选择渠道内容"
						@change="handleChangeG"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
					  >
						<a-select-option v-for="(value,key) in filterData.content_channel.list" :key="key" :value="key">
						  {{value}}
						</a-select-option>
					</a-select>
				</div>
				
				<!-- 作品选择 -->
				<div class="jl-screen-box">
					<tfBookSelect ref="getTfBook" s_width="260px" s_placeholder="作品" @handleChangeSelect="handleChangeZ"></tfBookSelect>
				</div>
				
				<a-button @click="searchButton('button')" :loading="search_button_loading" class="jl-screen-box" type="primary" icon="search">搜索</a-button>
			</div>
		</div>
	</div>
	</div>
	
	<div style="">
		<MPzhTable @table-th-click="tableThClick" @click-Fzr="clickFzr"
		:rableTitle="rableTitle" 
		:tableShowData="tableShowData" :tableSumData="tableSumData" 
		:table_scroll_width="table_scroll_width" :jj_checked="jj_checked" 
		:indeterminate="indeterminate" :checkAll="checkAll" :table_null_width="table_null_width"
		:page_type="'mp'"
		@click-All-Checkbox="onCheckAllChange" @click-Checkbox="onChangeCheckbox" @sync-zhxx-click="syncZhxxClick" 
		@sync-Checkbox="syncCheckbox" @click-tgnr="clickTgnr"></MPzhTable>
	</div>
	<!-- 分页 -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	<!-- 批量设置投手 -->
	<a-modal :visible="pl_modal" title="批量设置投手" okType="primary" width="700px"
	  okText="设置" cancelText="取消"
	  @ok="plOk" @cancel="plCancel" :confirmLoading="pl_loading">
	    <div style="">
			<div style="display: flex;align-items: center;">
				<div style="margin-right: 15px;font-size: 15px;">请选择要添加的投手</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择投手"
					@change="handleChangeD"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					:labelInValue="true"
					:value="pl_value"
				  >
					<a-select-option v-for="(item,index) in filterData.op_id.list" :key="item.key" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			<div style="display: flex;flex-wrap: wrap;margin: 15px 0 30px;max-height: 100px;overflow-y: auto;">
				<div style="width: 150px;display: flex;align-items: center;margin-bottom: 7px;" v-for="(item,index) in pl_select_admin" :key="index">
					<div style="margin-right: 12px;">{{item.label}}</div>
					<!-- <div style="color: red;cursor: pointer;">删除</div> -->
					<a-icon @click="delSelectAdmin(index)" type="close-circle" />
				</div>
			</div>
			<div style="margin-bottom: 10px;margin-top: 15px;">已选的账号名称：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
					<div style="width: 70px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 180px;">{{item.account_name}}</div>
				</div>
			</div>
			
			<!-- <div class="">id：4 —— 李永润</div> -->
		</div>
	</a-modal>
	
	<!-- 批量同步历史数据 -->
	<a-modal :visible="sync_modal" title="新建数据同步任务" okType="primary" width="700px"
	  okText="设置" cancelText="取消"
	  @ok="syncOk" @cancel="syncCancel" :confirmLoading="sync_loading">
	    <div style="">
			<div class="screen-box">
				<div class="screen-label">推广日期范围</div>
				<a-range-picker style="width:300px;" 
				@change="onChangeDateSync" 
				@openChange="syncOpenChange"
				@calendarChange="syncCalendarChange"
				:disabledDate="syncDisabledDate"
				:allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime_sync, dateFormat),this.moment(endTime_sync, dateFormat)]" />
			</div>
			
			<div style="margin-bottom: 10px;margin-top: 15px;">已选的账号名称：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
					<div style="width: 70px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 190px;">{{item.account_name}}</div>
				</div>
			</div>
			
			
		</div>
	</a-modal>
	
	<a-modal :visible="switch_modal" title="批量开启关闭同步数据" okType="primary" width="700px"
	  okText="设置" cancelText="取消" :footer="null" >
	    <div style="">
			<div style="margin-bottom: 10px;">已选的账号名称：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
					<div style="width: 70px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 190px;">{{item.account_name}}</div>
				</div>
			</div>
			
			<div class="form-cell-box" style="margin-top: 30px;justify-content: flex-end;">
				<a-button @click="switchOk(1)" v-if="open_control" :loading="s_open_loading" type="primary" style="margin-right: 20px;">批量开启</a-button>
				<a-button @click="switchOk(2)" v-if="close_control" :loading="s_close_loading" type="primary" style="margin-right: 20px;">批量关闭</a-button>
				<a-button @click="switchCancel">取消</a-button>
			</div>
		</div>
	</a-modal>
	
	<!-- 设置推广内容 -->
	<tgContentModal :ContentChannel="filterData.content_channel.list" :bookID="filterData.book_id.list" :selectedData="selectedData" 
	:adv_type="2" ref="getTgContent" @set-adv-ok="setAdvOk"></tgContentModal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { MPzhList, JLzhSelectGgzh , putDataMenu, accAgentEditFZR, MPzhSyncAdv, putUserList, MPzhSyncReport, MPzhSetSync} from '@/request/api'
import MPzhTable from '@/components/MPtable/MPzhTable.vue'
import tgContentModal from '@/views/Market/components/tgContentModal.vue'
import tfBookSelect from '@/components/selectCompont/tfBookSelect.vue'
export default {
	name: 'MPzh_',
	components: {
		MPzhTable, tgContentModal, tfBookSelect
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			startTime_sync: '2022-05-01', // 投放日期-开始时间
			endTime_sync: '2022-06-30', // 投放日期-结束时间
			
			jj_checked: true, // 精简模式，默认打开
			
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"账户名称",width:100, sort_status:0, type:"account_name", text_right: false,sort_:90,sort_control: false, show_control: true,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"投手",width:105, sort_status:0, type:"admin_name", text_right: false,sort_:89,sort_control: false, show_control: true,},
				{title:"推广内容",width:105, sort_status:0, type:"tgnr", text_right: false,sort_:89,sort_control: false, show_control: true,},
				{title:"同步数据",width:70, sort_status:0, type:"cz2.0", text_right: false,sort_:88,sort_control: false, show_control: true,},
				{title:"操作",width:70, sort_status:0, type:"cz", text_right: false,sort_:88,sort_control: false, show_control: true,},
				// 以下是数据项
				{title:"消耗",width:85, sort_status:0, type:"cost", text_right: true,sort_:87,sort_control: true, show_control: true,},
				{title:"展示数",width:85, sort_status:0, type:"show", text_right: true,sort_:86,sort_control: true, show_control: false,},
				{title:"ecpm",width:80, sort_status:0, type:"avg_show_cost", text_right: true,sort_:85,sort_control: true, show_control: false,},
				{title:"点击数",width:80, sort_status:0, type:"click", text_right: true,sort_:39,sort_control: true, show_control: false,},
				{title:"平均点击单价",width:80, sort_status:0, type:"avg_click_cost", text_right: true,sort_:38,sort_control: true, show_control: false,},
				{title:"点击率",width:80, sort_status:0, type:"ctr", text_right: true,sort_:37,sort_control: true, show_control: false,},
				// 新字段
				{title:"公众号关注数",width:110, sort_status:0, type:"follow_count", text_right: true,sort_:36,sort_control: true, show_control: true,},
				{title:"公众号关注成本",width:110, sort_status:0, type:"follow_cost", text_right: true,sort_:36,sort_control: true, show_control: true,},
				
				{title:"转化数",width:80, sort_status:0, type:"conversions_count", text_right: true,sort_:36,sort_control: true, show_control: true,},
				{title:"平均转化成本",width:80, sort_status:0, type:"conversions_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"转化率",width:80, sort_status:0, type:"conversions_rate", text_right: true,sort_:35,sort_control: true, show_control: false,},
				
				{title:"当天总充值金额",width:85, sort_status:0, type:"eff_total_pay_money", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天分成金额",width:85, sort_status:0, type:"eff_total_left_money", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天首充分成金额",width:85, sort_status:0, type:"eff_total_left_money_fisrt", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天总ROI",width:70, sort_status:0, type:"eff_roi", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天首充ROI",width:80, sort_status:0, type:"eff_roi_first", text_right: true,sort_:35,sort_control: true, show_control: true,},
				
				{title:"当天订单笔数",width:80, sort_status:0, type:"eff_total_order_cnt", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天充值用户数",width:90, sort_status:0, type:"eff_total_pay_user_cnt", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天充值用户成本",width:90, sort_status:0, type:"eff_total_pay_user_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"ARPU",width:80, sort_status:0, type:"arpu", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"回传用户数",width:80, sort_status:0, type:"eff_report_pay_user_cnt", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"回传用户成本",width:80, sort_status:0, type:"eff_report_pay_user_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				// 以下是基本信息
				{title:"账户ID",width:140, sort_status:0, type:"account_id", text_right: false,sort_:35,sort_control: false, show_control: true,},
			],
			tableShowData: [], // 显示表格内容
			tableSumData: {}, // 总计

			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			r_adv_id: [], // 选择的广告账户
			r_sort_field: "", // 排序参数
			r_sort_type: "", // 排序类型
			r_admin_id: [], // 选择投手
			
			r_account_name: "", // 广告账户名称
			r_account_id: "", // 广告账户ID
			
			r_content_type: undefined, // 渠道内容
			r_book_id: undefined, // 作品id
			
			filterData: {
				op_id:{
					list: [{}],
				},
				channel_id:{
					list: [{}],
				},
				book_type: {
					list: [{}],
				},
				content_channel: {
					list: [{}],
				},
				book_id: {
					list: [{}],
				}
			}, 
			personChargeList: {}, // 投手
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selectedData: [], // 选择内容存放数组
			
			// 批量设置投手
			pl_modal: false,
			pl_loading: false,
			pl_select_admin: [],
			pl_value: undefined, // 选择框的默认值
			
			role_control: [], // 用户权限控制
			
			// 批量同步历史数据
			sync_modal: false, // 弹窗控制
			sync_loading: false, // 加载中的状态
			disabledCurrent: null,
			
			switch_modal: false, // 开启关闭同步数据弹窗控制
			open_control: true, // 批量开关同步数据弹窗的按钮控制-开启
			close_control: true, // 批量开关同步数据弹窗的按钮控制-关闭
			s_open_loading: false, // 按钮的加载状态
			s_close_loading: false, // 按钮的加载状态
			
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			if(res.show_control){
				nn = nn + res.width
			}
		})
		that.table_scroll_width = nn + 30 + 30 // 第一个30是为了多出30px的宽度，然后表格右边留白。第二个30是为了表格左边的单选框
		if(that.table_scroll_width >= that.body_width){ that.table_null_width = that.body_width - 60 }
		else { that.table_null_width = that.table_scroll_width - 60 }
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		
		// 获取7天前日期
		let date1 = new Date(new Date().getTime() - 604800000);
		let month1
		if(date1.getMonth() + 1 < 10){
			month1 = '0' + (date1.getMonth() + 1)
		}
		else {
			month1 = date1.getMonth() + 1
		}
		let day1
		if(date1.getDate() < 10){
			day1 = "0" + date1.getDate()
		}
		else {
			day1 = date1.getDate()
		}
		// that.startTime = date1.getFullYear() + "-" + month1 + "-" + day1
		
		// 获取当前日期
		let date2 = new Date();
		let month2
		if(date2.getMonth() + 1 < 10){
			month2 = '0' + (date2.getMonth() + 1)
		}
		else {
			month2 = date2.getMonth() + 1
		}
		let day2
		if(date2.getDate() < 10){
			day2 = "0" + date2.getDate()
		}
		else {
			day2 = date2.getDate()
		}
		// console.log("date2.getDate();",date2.getDate())
		that.endTime = date2.getFullYear() + "-" + month2 + "-" + day2;
		that.startTime = date2.getFullYear() + "-" + month2 + "-" + day2; // 默认只获取当天
		that.startTime_sync = that.endTime
		that.endTime_sync = that.endTime
		
		// 获取角色权限
		that.role_control = JSON.parse(localStorage.getItem("role_limits"))
		
		// 投手
		putUserList().then(res=>{
			console.log("投手",res);
			that.personChargeList = res.data.data.list
		})
		
		putDataMenu().then(res=>{
			console.log("获取搜索条件",res);
			that.filterData = res.data.data.filter
		})
		
		// 获取作品
		that.$nextTick(()=>{
			that.$refs.getTfBook.getSelectData()
		})
		
		// 搜索
		that.searchButton()
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 同步历史数据-推广日期范围 
		onChangeDateSync(date, dateString) {
			console.log(date, dateString);
			this.startTime_sync = dateString[0]
			this.endTime_sync = dateString[1]
		}, 
		// 精简模式
		onJJChange(e){
			console.log(!e);
			
			this.rableTitle.forEach(res=>{
				// console.log(res);
				if(res.title == "展示数" || res.title == "ecpm" || res.title == "点击数" || res.title == "平均点击单价" || res.title == "点击率" || res.title == "转化率" || res.title == "当天总充值金额" || res.title == "当天首充分成金额" || res.title == "当天订单笔数"){
					if(e){ // 精简模式打开
						res.show_control = false
					}
					else {  // 精简模式关闭，显示内容
						res.show_control = true
					}
					
				}
			})
			
			let nn = 0
			this.rableTitle.forEach((res,index)=>{
				if(res.show_control){
					nn = nn + res.width
				}
			})
			this.table_scroll_width = nn + 30 + 30
			
			this.jj_checked = e
			
			// 给母页面的tab传递粘性定位用的参数
			this.$bus.$emit("stickyData", this.table_scroll_width);
		},
		handleChangeA(e){ // 选择投手
			console.log(e);
			// 未设置的选项与其他选项不可以同时选，所以这里要加限制
			if(e.length > 1 && e.indexOf('-1') > -1){
				this.$message.warning('未设置与其他选项不能同时选择');
			}
			else {
				this.r_admin_id = e
			}
		},
		handleChangeG(e){ // 渠道内容
			this.r_content_type = e
			let eee = 1
			if(e == 3){
				eee = 2
			}
			this.$refs.getTfBook.changeType(eee)
		},
		handleChangeZ(e){ // 作品
			this.r_book_id = e
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
				
				// 这个页面经常需要通过消费的排序或其他排序来看数据，所以这里清空的话，每次搜索就要重新点排序，麻烦，干脆注释
				// 排序的状态重置
				// that.r_sort_field = ''
				// that.r_sort_type = ''
				// that.rableTitle.forEach(res=>{
				// 	res.sort_status = 0 // 排序的状态重置
				// })
				
			}
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				start_time: that.startTime.replace(/-/g, ''),
				end_time: that.endTime.replace(/-/g, ''),
				is_wechat_account: "1", // 账户类型，1表示MP，2表示ADQ
				
				adv_id: that.r_adv_id,
				
				content_channel: that.r_content_type,
				book_id: that.r_book_id,
			}
			if(that.r_account_name){
				r_data.account_name = that.r_account_name
			}
			if(that.r_account_id){
				r_data.account_id = that.r_account_id
			}
			
			// 超级管理、投放管理可以有 投手
			if(Object.keys(that.personChargeList).length > 0){
				r_data.admin_id = that.r_admin_id // 选择投手
			}
			// 如有排序字段就加上
			if(that.r_sort_field){ 
				r_data.order = that.r_sort_field
				r_data.sort = that.r_sort_type
			}
			MPzhList(r_data).then(res=>{
				console.log('搜索',res);
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
					let data = res.data.data.data
					data.forEach(res=>{
						res.checked = false // 用于多选和单选
						res.popover_clicked = false // 操作栏的气泡卡片
						res.popover_clicked2 = false // 2.0操作栏的气泡卡片
						if(res.sync_data == 1){
							res.sync_checked = true // 同步2.0数据-开启
						}
						else {
							res.sync_checked = false // 同步2.0数据-关闭
						}
					})
					
					// 这个页面的选择框其实是没有相关功能的。所以这里就写这些。
					console.log("that.checkAll",that.checkAll)
					that.checkAll = false
					that.indeterminate = false
					that.selectedData = []
					
					that.search_button_loading = false
					that.$message.success('搜索成功');
					that.tableSumData = res.data.data.sum
					that.table_total = res.data.data.total
					that.tableShowData = data
				}
				else {
					
					that.checkAll = false
					that.indeterminate = false
					that.selectedData = []
					
					that.search_button_loading = false
					
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
				
			})
			.catch(err=>{
				// 重置状态
				that.selectedData = []
				that.checkAll = false
				that.indeterminate = false
				
				that.search_button_loading = false
				
				that.$message.error('搜索失败，请检查网络状态')
			})
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 点击投手
		clickFzr(e){
			console.log(e)
			let that = this
			this.selectedData = []
			this.selectedData.push(e)
			
			for(let key in e.admin_user){
				// console.log(key)
				let obj = {
					label: e.admin_user[key],
					key: key
				}
				this.pl_select_admin.push(obj)
			}
			
			
			this.pl_modal = true
		},
		
		// 批量设置投手，选择投手
		handleChangeD(e){
			console.log(e);
			this.pl_value = e
			
			// 下面是多选部分
			let ttt = true
			this.pl_select_admin.forEach(res=>{
				if(res.key == e.key){
					ttt = false
				}
			})
			if(ttt){
				this.pl_select_admin.push(e)
			}
		},
		// 批量设置投手弹窗确认按钮
		plOk(){
			let that = this
			if(that.pl_select_admin.length > 0){ // 得选择投手
				that.pl_loading = true
				let a_data = []
				that.pl_select_admin.forEach(res=>{
					a_data.push(res.key)
				})
				// console.log("a_data",a_data);
				
				let i_data = []
				that.selectedData.forEach(res=>{
					i_data.push(res.id)
				})
				// console.log("i_data",i_data);
				
				accAgentEditFZR({
					admin_id: a_data, 
					ids: i_data,
				}).then(res=>{
					that.pl_loading = false
					console.log("批量设置投手",res);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.selectedData = []
						that.plCancel()
						that.$message.success('设置成功');
						that.searchButton()
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
			else {
				this.$message.warning('请先选择投手');
			}
			
			
		},
		// 删除选择的投手
		delSelectAdmin(index){
			this.pl_select_admin.splice(index,1)
		},
		// 批量设置投手弹窗取消按钮
		plCancel(){
			if(this.pl_loading){
				return 
			}
			this.pl_select_admin = []
			this.pl_modal = false
			this.pl_value = undefined
		},
		
		// 全选
		onCheckAllChange(e){
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				
				that.indeterminate = false
				that.checkAll = true
				
			}
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
			// that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			
		},
		
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			// console.log(that.r_sort_field);
			// console.log(that.r_sort_type);
			that.searchButton()
		},
		
		// 同步账户信息
		syncZhxxClick(item,type){
			let that = this
			console.log(item);
			// console.log("type",type);
			if(type == 1){ // 同步账户信息
				if(!that.search_button_loading){
					that.search_button_loading = true
					let rrr = []
					rrr.push(item.account_id) 
					MPzhSyncAdv({
						id: rrr
					}).then(res=>{
						that.search_button_loading = false
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
							console.log("同步账户信息",res);
							that.$message.success(res.data.msg || '同步中，请刷新页面查看');
							// that.searchButton()
						}
						else {
							if(res.data.code == 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
							}
							else {
								that.$message.error(`错误：${res.data.msg}`);
							}
						}
					})
					.catch(err=>{
						that.search_button_loading = false
					})
				}
			}
			else if(type == 5){ // 同步历史数据
				that.selectedData = []
				that.checkAll = false
				that.indeterminate = false
				that.tableShowData.forEach((res,index)=>{
					res.checked = false
				})
				that.selectedData.push(item)
				
				that.sync_modal = true
				
			}
			
		},
		
		// 批量操作
		handleButtonClick(e) {
		    console.log('click left button', e);
		},
		// 批量操作按钮点击
		handleMenuClick(e) {
			let that = this
		    console.log('click', e);
			if(this.selectedData.length > 0){
				let that = this
				if(e.key == '1'){ // 同步历史数据
					// that.search_button_loading = true
					that.sync_modal = true
				}
				else if(e.key == '2'){ // 批量同步账户信息
					// console.log("that.selectedData",that.selectedData);
					that.search_button_loading = true
					let rrr = []
					that.selectedData.forEach(res=>{
						rrr.push(res.account_id)
					})
					// rrr.push(item.id) 
					MPzhSyncAdv({
						id: rrr
					}).then(res=>{
						that.search_button_loading = false
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
							console.log("同步账户信息",res);
							that.$message.success(res.data.msg || '同步中，请刷新页面查看');
							
							// 清空选中状态
							that.clearPlSelect()
						}
						else {
							if(res.data.code == 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
							}
							else {
								that.$message.error(`错误：${res.data.msg}`);
							}
						}
					})
					.catch(err=>{
						that.search_button_loading = false
					})
					
				}
				else if(e.key == '3'){ // 开启关闭同步数据
					that.switch_modal = true
				}
				else if(e.key == '7'){ // 设置推广内容
					that.$nextTick(()=>{
						that.$refs.getTgContent.plTg()
					})
					
				}
			}
			else {
				this.$message.warning('还没有选择内容');
			}
			
		},
		// 批量操作后，清楚表格的选中状态
		clearPlSelect(){
			let that = this
			that.selectedData = []
			that.checkAll = false
			that.indeterminate = false
			that.tableShowData.forEach((res,index)=>{
				res.checked = false
			})
		},
		
		// 弹出日历和关闭日历的回调
		syncOpenChange (status) {
		  // 清空禁用时间段的设置
		  this.disabledCurrent = null
		},
		// 待选日期发生变化的回调
		syncCalendarChange(dates){
			console.log(dates);
			console.log(moment(dates[0]).subtract(3, 'month'));
			// 获取手动选择的时间段起始值
			this.disabledCurrent = dates[0]
		},
		// 禁止选择范围
		// 1、时间限制范围 开始时间~结束时间不能超过一个月，且禁选超过当前日期时间
		syncDisabledDate (current) {
			// 注释的这段代码的意思是：开始时间~结束时间不能超过7天，且禁选超过当前日期时间
		    // if (!this.disabledCurrent) return current > moment()
		    // return (current && current < moment(this.disabledCurrent).subtract(6, 'days').startOf('day')) || current > moment(this.disabledCurrent).add(6, 'days').endOf('day') || current > moment()
			return current && current > moment().endOf('day') || current < moment().subtract(90, 'day');
		},
		
		onChangeTimer (value, data) {
		    this.dataList.forEach((item, i) => {
				if (item.name === data) {
		          item.value = value
		        }
		    })
		},
		// 同步弹窗确认按钮
		syncOk(){
			let that = this
			
			that.sync_loading = true
			
			let a_ids = []
			
			console.log("that.selectedData",that.selectedData);
			that.selectedData.forEach((res,index)=>{
				a_ids.push(res.account_id)
			})
			
			MPzhSyncReport({
				ids: a_ids,
				start_date: that.startTime_sync,
				end_date: that.endTime_sync,
			}).then(res=>{
				console.log("同步历史数据",res);
				that.sync_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					console.log("同步历史数据",res);
					
					// 清空选中状态
					that.clearPlSelect()
					
					that.syncCancel()
					that.$confirm({
						title: '同步历史数据成功',
						icon:"exclamation-circle",
						class:'jlzh',//类名
						okText: "查看任务进度",
						cancelText: "取消",
						content: h => <div >点击按钮前往-同步任务列表，查看任务进度</div>,
						onOk() {
						  console.log('OK');
						  // that.$router.push({path: '/taskSync'});
						  const { href } = that.$router.resolve('/taskSync')
						  window.open(href, '_blank');
						},
						onCancel() {
						  console.log('Cancel');
						},
						
					});
						
					
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		syncCancel(){
			if(this.sync_loading){
				return
			}
			
			// this.selectedData = []
			this.sync_modal = false
		},
		
		// 同步数据 开启/关闭
		syncCheckbox(e,item){
			let that = this
			console.log(e,item);
			if(e){ // e的值为true，表示要进行开启操作
				let arr = []
				arr.push(item.id)
				MPzhSetSync({
					ids: arr,
					status: 1, // 是
				}).then(res=>{
					console.log("同步数据-开启",res);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						
						that.$message.success('同步数据开启成功');
						that.searchButton()
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
			else { // e的值为false，表示要进行关闭操作
				let arr =[]
				arr.push(item.id)
				MPzhSetSync({
					ids: arr,
					status: 0, // 否
				}).then(res=>{
					console.log("同步数据-关闭",res);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						
						that.$message.success('同步数据关闭成功');
						that.searchButton()
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
		},
		
		
		// 批量开启关闭同步数据
		switchOk(e){
			let that = this
			console.log(e);
			let sss = 0
			if(e == 1){ // 进行开启操作
				sss = 1
				that.s_open_loading = true
			}
			else if(e == 2){ // 进行关闭操作
				sss = 0
				that.s_close_loading = true
			}
			
			let rrr = []
			that.selectedData.forEach(res=>{
				rrr.push(res.id)
			})
			console.log("that.selectedData",that.selectedData);
			console.log("rrr",rrr);
			console.log("sss",sss);
			
			MPzhSetSync({
				ids: rrr,
				status: sss, 
			}).then(res=>{
				console.log("同步数据-开启",res);
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.s_open_loading = false
					that.s_close_loading = false
					if(e == 1){ // 进行开启操作
						that.$message.success('同步数据批量开启成功');
					}
					else if(e == 2){ // 进行关闭操作
						that.$message.success('同步数据批量关闭成功');
					}
					that.switchCancel()
					that.searchButton()
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 关闭
		switchCancel(){
			// this.open_control = false // 批量开关同步数据弹窗的按钮控制-开启
			// this.close_control = false // 批量开关同步数据弹窗的按钮控制-关闭
			this.s_open_loading = false // 按钮的加载状态
			this.s_close_loading = false // 按钮的加载状态
			
			this.switch_modal = false
		},
		
		// 推广内容设置相关
		setAdvOk(){
			this.searchButton()
		},
		clickTgnr(item){
			let that = this
			
			that.$refs.getTgContent.clickTgnr(item)
			
		},
	},
	
}
</script>

<style>
</style>